import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import KpiGraph from './KpiGraph';//eslint-disable-line import/no-named-as-default
import KpiResultsPanel from './KpiResultsPanel';//eslint-disable-line import/no-named-as-default
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as localStorage from '../../../localStorage/localStorage';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class KpiGraphResults extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            userDataKpis: appHelper.getArrayObjectByKey(this.props.userData.bites, "bite_id", this.props.callbacks.getBiteId()).kpis,
            renderableKpis: [],
            completeKpis:[],
            activeKpi:{},
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            icon: {
                src: "",
            },
            screenStatus:"",
            checkComplete: false,
            updateKpis: false,
            kpiMenuData:{
                menu:[],
                currentKpi:{},
                onMenuSelect:{},
                idKey: "kpi_id",
                labelKey: "label"
            },
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(),this.props.callbacks.getScreenId(),this.props.screenObject.asset_id),
            isComplete: false,
            progressionHandled: false,
            continue_label: appHelper.getLocaleString("continue_label")
        };
        this.handleProgression = this.handleProgression.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.getKpisToDisplay = this.getKpisToDisplay.bind(this);
        this.onSelectKpi = this.onSelectKpi.bind(this);
        this.onKpiComplete = this.onKpiComplete.bind(this);
    }

    componentDidMount() {
        let biteData = appHelper.getArrayObjectByKey(localStorage.bites,"bite_id",this.props.callbacks.getBiteId());
        let kpis = kpiHelper.getKpis(biteData);
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }

        this.getAssets();
        this.getScreenStatus();
        this.show();
        this.getKpisToDisplay();
    }

    componentWillReceiveProps(nextProps) {


        if(this.state.userData !== nextProps.userData){

            let userDataKpis = appHelper.getArrayObjectByKey(nextProps.userData.bites, "bite_id", this.props.callbacks.getBiteId()).kpis;
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                userDataKpis: Object.assign([],userDataKpis),
                updateKpis: true
            });
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                continue_label: appHelper.getLocaleString("continue_label"),
                updateKpis: true
            });
        }
    }

    componentDidUpdate(){

        if(this.state.checkComplete){
            this.onComplete();
        }

        if(this.state.updateKpis){
            this.getKpisToDisplay();
        }
    }
    getScreenStatus(){
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {

        if(this.state.screenStatus === objectConstants.STATUS_COMPLETE){
            this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true, completeKpis: Object.assign([],this.state.renderableKpis)});
        }else{
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)){
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                }else{
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if(objectUserData.status === objectConstants.STATUS_COMPLETE){
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true, completeKpis: Object.assign([],this.state.renderableKpis)});
            }else{
                this.setState({checkComplete: true});
            }

        }
    }

    getKpisToDisplay(){
        let renderableKpis =  [];
        let biteData = appHelper.getArrayObjectByKey(localStorage.bites,"bite_id",this.props.callbacks.getBiteId());
        let kpis = kpiHelper.getAllKpis(biteData);

        for(let i = 0; i < kpis.length; i++){
            let kpi = kpis[i];
            let kpiDataObj = {
                kpi_id: kpi.kpi_id,
                data: kpi,
                userData: appHelper.getArrayObjectByKey(this.state.userDataKpis,"kpi_id",kpi.kpi_id)
            };
            renderableKpis = dataHelper.immutablePush(renderableKpis,kpiDataObj);
        }

        let activeIndex = 0;
        if(appHelper.isDefined(this.state.activeKpi.kpi_id)){
            activeIndex = appHelper.getArrayObjectIndexByKey(renderableKpis,"kpi_id",this.state.activeKpi.kpi_id);
        }


        if(this.state.screenObject.display_method === objectConstants.RESULT_DISPLAY_METHOD_SCORE_ONLY){
            renderableKpis = kpiHelper.removeObjectivesFromKpisToDisplay(renderableKpis);
        }else if(this.state.screenObject.display_method === objectConstants.RESULT_DISPLAY_METHOD_OBJECTIVES_ONLY){
            renderableKpis = kpiHelper.removeScoreFromKpisToDisplay(renderableKpis);
            if(this.state.screenObject.hide_objectives.length > 0) {
                renderableKpis =  kpiHelper.removeKpisFromKpisToDisplay(renderableKpis, this.state.screenObject.hide_objectives);
            }
        }else{
            if(this.state.screenObject.hide_objectives.length > 0) {
                renderableKpis = kpiHelper.removeKpisFromKpisToDisplay(renderableKpis, this.state.screenObject.hide_objectives);
            }
        }

        let kpiMenu = kpiHelper.setKpiMenuData(renderableKpis);

        this.setState({
            updateKpis: false,
            renderableKpis: Object.assign([],renderableKpis),
            completeKpis: this.state.status === objectConstants.STATUS_COMPLETE ? renderableKpis : this.state.completeKpis,
            activeKpi:renderableKpis[activeIndex],
            kpiMenuData: Object.assign({},this.state.kpiMenuData, {
                menu: kpiMenu,
                currentKpi: !appHelper.isDefined(this.state.kpiMenuData.currentKpi.kpi_id) ? kpiMenu[0] : kpiMenu[activeIndex],
                onMenuSelect: this.onSelectKpi,
            })
        });
    }

    onSelectKpi(result){
        let activeKpi = appHelper.getArrayObjectByKey(this.state.renderableKpis,"kpi_id",result.kpi_id);
        let activeMenuItem = appHelper.getArrayObjectByKey(this.state.kpiMenuData.menu,"kpi_id",result.kpi_id);
        this.setState({
            activeKpi:activeKpi,
            kpiMenuData: Object.assign({},this.state.kpiMenuData, {
                currentKpi:activeMenuItem,
            })
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getAssets() {
        if (appHelper.isDefined(this.state.screenObject.icon)) {
            let icon = appHelper.getIconAsset(this.state.screenObject.icon);
            if (appHelper.isDefined(icon) && icon.src.length > 0) {
                this.setState({icon: icon});
            }
        }
    }
    show() {
        let optionRef = this.refs[`${this.state.screenObject.asset_id}_asset`];
        TweenLite.set(optionRef, {height: "auto"});
        TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
            height: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.getObjectStatus);
    }


    onShowComplete() {
        this.setState({isVisible: true, checkComplete: false});
    }


    scrollToTop() {
        if(this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
            let question = this.refs[`${this.state.screenObject.asset_id}_asset`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(question.offsetTop);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        if(this.state.renderableKpis.length === this.state.completeKpis.length && !this.state.isComplete) {

            let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
                if (!hasNextObject) {
                    this.handleProgression();
                    this.enableProgression();
                } else {
                    this.enableProgression();
                }

            } else {
                this.handleProgression();
            }
        }

    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        if(!this.state.progressionHandled) {

            this.setState({progressionHandled: true});
            let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
            let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
            let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
            let completionData = {
                progression: progressionRule,
                progressionType: progressionType,
                progressionGoToId: progressionGoToId,
                asset_id: this.state.screenObject.asset_id,
                status: objectConstants.STATUS_COMPLETE,
                showProgressionButton: false,
                asset_type_code: this.state.screenObject.asset_type_code,
                navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
                index: this.props.index
            };

            this.props.callbacks.onObjectComplete(completionData);
        }
        //t

    }

    onProgressionBtnClicked(){
        this.setState({showProgressionButton: false});
        if(this.props.callbacks.hasNextObject(this.props.index)){
            this.handleProgression();
        }else{
            this.props.callbacks.navigateToNextScreen();
        }
    }

    onKpiComplete(kpi){
        let index = appHelper.getArrayObjectIndexByKey(this.state.completeKpis,"kpi_id",kpi.kpi_id);
        if(index === -1){
            this.setState({
                completeKpis: dataHelper.immutablePush(this.state.completeKpis,kpi),
                checkComplete: true,
            });
        }
    }

    render() {
        return (
            <div className={`object-container`} ref={`${this.state.screenObject.asset_id}_asset`}>
                {
                    this.state.screenObject.show_title
                        ?
                        <h4 dangerouslySetInnerHTML={{__html:this.state.locale.label}} />
                        :
                        null
                }
                <div>
                    {
                        appHelper.isDefined(this.state.activeKpi) && appHelper.isDefined(this.state.activeKpi.userData)
                            ?
                            <KpiResultsPanel kpiData={this.state.activeKpi.data} userDataKpi={this.state.activeKpi.userData} bite_id={this.props.callbacks.getBiteId()} asset_id={this.state.screenObject.asset_id} kpiMenuData={this.state.kpiMenuData} onComplete={this.onKpiComplete} completeKpis={this.state.completeKpis}/>
                            :
                            null
                    }
                    {
                        appHelper.isDefined(this.state.activeKpi) && appHelper.isDefined(this.state.activeKpi.userData)
                        ?
                            <KpiGraph kpiData={this.state.activeKpi.data} userDataKpi={this.state.activeKpi.userData}/>
                        :
                            null
                    }
                </div>
                {this.state.showProgressionButton
                    ? <Button label={this.state.continue_label}
                              id={`${this.state.screenObject}_button`}
                              onClick={this.onProgressionBtnClicked}/>
                    : null
                }
            </div>
        );
    }
}

KpiGraphResults.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

KpiGraphResults.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KpiGraphResults);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiGraphResults.js
 **/